import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { NotTranslatedService } from '../helpers/not-translated-service.service';

@Injectable()
export class LoyalticMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    this.nts.notTranslated(params.key);
    return ' ✎ ' + params.key;
  }

  constructor(private nts: NotTranslatedService) {}
}
